// extracted by mini-css-extract-plugin
export default {"cell":"date-and-time-cell-renderer_cell__hTf2F"};